import Skeleton from '@mui/material/Skeleton';
import type { HtmlElementProps } from '@/types';
import { classes, styles } from './utils';

export interface SkeletonListItemProps extends HtmlElementProps<HTMLLIElement> {
  delay?: number;
  duration?: number;
}

export default function SkeletonListItem({
  delay = 0.2,
  duration = 1.2,
  ...props
}: SkeletonListItemProps) {
  return (
    <li {...props}>
      <Skeleton
        sx={styles.skeleton(delay, duration)}
        className={classes.skeleton}
        variant="rectangular"
        animation="wave"
      />
    </li>
  );
}
